/* ELLESANTI · tema V3 · comportamento del sistema (dal prototipo V8). CTRL+G · 29/09/2026. Nessuna libreria.
   Header (trasparente sulla foto, pieno quando scorri, si nasconde scendendo), megamenu (intenzione 120 ms, tolleranza 200 ms),
   aiuto, cassetto mobile, fisarmoniche, barra annunci, comparse allo scorrimento, segni che si disegnano, WhatsApp.
   Ogni parte si inizializza per sezione: nell'editor di Shopify riparte quando la sezione viene ricaricata. */
(function () {
  'use strict';
  var H = document.documentElement;
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var onMq = function (fn) { if (mqDesk.addEventListener) mqDesk.addEventListener('change', fn); else if (mqDesk.addListener) mqDesk.addListener(fn); };
  var clamp = function (x, a, b) { return Math.min(b, Math.max(a, x)); };

  H.classList.add('e-js');
  function redraw(s) { if (!s) return; s.classList.remove('is-drawn'); void s.getBoundingClientRect(); s.classList.add('is-drawn'); }
  function setVW() { H.style.setProperty('--e-vw', H.clientWidth + 'px'); }
  setVW();
  window.addEventListener('resize', setVW);

  /* ---------------------------------------------------------------- header, megamenu, aiuto, cassetto */
  function initHeader(scope) {
    var hd = (scope && scope.matches && scope.matches('[data-e-hd]')) ? scope : $('[data-e-hd]', scope || document);
    if (!hd || hd._e) return;
    hd._e = true;
    var sec = hd.closest('.e-hd-section') || hd.parentNode;
    var over = hd.getAttribute('data-over') === 'true';
    var hide = hd.getAttribute('data-hide') === 'true';
    var mega = $('[data-e-mega]', hd), dim = $('[data-e-dim]', hd);
    var aiuto = $('[data-e-aiuto]', hd), aiutoB = $('[data-e-aiuto-btn]', hd);
    var voci = $$('[data-e-voce]', hd);
    var drawer = $('[data-e-drawer]', sec), burger = $('[data-e-burger]', hd);
    var lastY = window.scrollY, current = null, openT = 0, closeT = 0, lastFocus = null;

    function busy() { return !!current || (aiuto && aiuto.classList.contains('is-open')) || H.classList.contains('e-drawer-open'); }
    function onScroll() {
      if (!document.body.contains(hd)) return;
      var y = window.scrollY;
      hd.classList.toggle('is-solid', !over || busy() || y > 40);
      if (hide && !busy()) {
        if (y > 640 && y > lastY + 4) sec.classList.add('is-hidden');
        else if (y < lastY - 4 || y < 640) sec.classList.remove('is-hidden');
      } else sec.classList.remove('is-hidden');
      H.classList.toggle('e-hd-hidden', sec.classList.contains('is-hidden'));
      lastY = y;
    }
    function panel(i) { return mega ? $('[data-e-mp="' + i + '"]', mega) : null; }
    function openPanel(i) {
      i = String(i);
      var p = panel(i);
      if (!p) return;
      clearTimeout(closeT);
      var was = current;
      current = i;
      mega.classList.add('is-open');
      if (dim) dim.classList.add('is-on');
      $$('.e-mp', mega).forEach(function (x) { x.classList.toggle('is-on', x === p); });
      voci.forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-e-voce') === i ? 'true' : 'false'); });
      closeAiuto(true);
      if (was !== i) $$('.e-mrow .e-segno', p).forEach(function (s, k) { s.classList.remove('is-drawn'); setTimeout(function () { s.classList.add('is-drawn'); }, 120 + k * 40); });
      onScroll();
    }
    function closePanel() {
      if (!mega || !current) return;
      current = null;
      mega.classList.remove('is-open');
      if (dim) dim.classList.remove('is-on');
      $$('.e-mp', mega).forEach(function (x) { x.classList.remove('is-on'); });
      voci.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      onScroll();
    }
    voci.forEach(function (b) {
      var i = b.getAttribute('data-e-voce');
      b.addEventListener('mouseenter', function () {
        if (!mqDesk.matches) return;
        clearTimeout(openT); clearTimeout(closeT);
        if (current) openPanel(i); else openT = setTimeout(function () { openPanel(i); }, 120);
      });
      b.addEventListener('mouseleave', function () { clearTimeout(openT); });
      b.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(openT); if (current === i) closePanel(); else openPanel(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); openPanel(i);
          var f = $('.e-mp.is-on a', mega);
          if (f) setTimeout(function () { f.focus(); }, 60);
        }
      });
    });
    hd.addEventListener('mouseleave', function () { clearTimeout(openT); if (current) closeT = setTimeout(closePanel, 200); });
    hd.addEventListener('mouseenter', function () { clearTimeout(closeT); });
    hd.addEventListener('focusout', function (e) { if (current && e.relatedTarget && !hd.contains(e.relatedTarget)) closePanel(); });
    if (dim) dim.addEventListener('click', function () { closePanel(); closeAiuto(); });

    /* la riga si accende; nel pannello Momenti cambia la foto e la didascalia */
    $$('.e-mp [data-e-row]', hd).forEach(function (row) {
      function on() {
        var p = row.closest('.e-mp'), k = +row.getAttribute('data-e-row');
        $$('[data-e-row]', p).forEach(function (r) { r.classList.toggle('is-on', r === row); });
        var box = $('[data-e-imgs]', p);
        if (box) {
          $$('img, .e-mp__img-vuota', box).forEach(function (im, j) { im.classList.toggle('is-on', j === k); });
          var cap = $('[data-e-cap]', box);
          if (cap) cap.textContent = row.getAttribute('data-cap') || '';
        }
        redraw($('.e-segno', row));
      }
      row.addEventListener('mouseenter', on);
      row.addEventListener('focus', on);
    });

    function openAiuto() {
      if (!aiuto) return;
      closePanel();
      aiuto.classList.add('is-open');
      if (aiutoB) aiutoB.setAttribute('aria-expanded', 'true');
      onScroll();
    }
    function closeAiuto(silent) {
      if (!aiuto || !aiuto.classList.contains('is-open')) return;
      aiuto.classList.remove('is-open');
      if (aiutoB) aiutoB.setAttribute('aria-expanded', 'false');
      if (!silent) onScroll();
    }
    if (aiutoB) aiutoB.addEventListener('click', function (e) { e.stopPropagation(); if (aiuto.classList.contains('is-open')) closeAiuto(); else openAiuto(); });
    document.addEventListener('click', function (e) {
      if (aiuto && aiuto.classList.contains('is-open') && !aiuto.contains(e.target) && !(aiutoB && aiutoB.contains(e.target))) closeAiuto();
    });

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      H.classList.add('e-drawer-open', 'e-lock');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      onScroll();
      var c = $('[data-e-close]', drawer);
      if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 60);
      $$('.e-acc.is-open .e-segno', drawer).forEach(redraw);
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      H.classList.remove('e-drawer-open', 'e-lock');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      onScroll();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawer) {
      $$('[data-e-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
      drawer.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (a && (a.getAttribute('href') || '').indexOf('#') > -1) closeDrawer();
      });
    }
    onMq(function () { closeDrawer(); closePanel(); closeAiuto(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (current) { var b = $('[data-e-voce="' + current + '"]', hd); closePanel(); if (b) b.focus(); }
      closeAiuto(); closeDrawer();
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    hd._api = { open: openPanel, close: closePanel, openDrawer: openDrawer, closeDrawer: closeDrawer };
  }

  /* ---------------------------------------------------------------- fisarmoniche (cassetto, footer mobile, pagine) */
  function initAcc(scope) {
    $$('[data-e-acc-btn]', scope).forEach(function (b) {
      if (b._e) return;
      b._e = true;
      b.addEventListener('click', function () {
        var item = b.closest('[data-e-acc]');
        if (!item) return;
        if (item.hasAttribute('data-e-acc-mobile') && mqDesk.matches) return;
        var group = item.parentElement, open = item.classList.contains('is-open');
        if (group && group.hasAttribute('data-e-acc-group')) {
          Array.prototype.forEach.call(group.children, function (x) {
            if (x !== item && x.hasAttribute && x.hasAttribute('data-e-acc')) {
              x.classList.remove('is-open');
              var bb = $('[data-e-acc-btn]', x);
              if (bb) bb.setAttribute('aria-expanded', 'false');
            }
          });
        }
        item.classList.toggle('is-open', !open);
        b.setAttribute('aria-expanded', !open ? 'true' : 'false');
        if (!open) $$('.e-segno', item).forEach(redraw);
      });
    });
    syncAcc();
  }
  /* le fisarmoniche solo mobile (colonne del footer): da desktop il bottone è un titolo, fuori dal giro del tab */
  function syncAcc() {
    $$('[data-e-acc-mobile]').forEach(function (item) {
      var b = $('[data-e-acc-btn]', item);
      if (!b) return;
      if (mqDesk.matches) {
        b.setAttribute('tabindex', '-1'); b.setAttribute('role', 'heading'); b.setAttribute('aria-level', '2'); b.removeAttribute('aria-expanded');
      } else {
        b.removeAttribute('tabindex'); b.removeAttribute('role'); b.removeAttribute('aria-level');
        b.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      }
    });
  }
  onMq(syncAcc);

  /* ---------------------------------------------------------------- barra annunci: una frase alla volta */
  function initAnn(scope) {
    $$('[data-e-ann]', scope).forEach(function (a) {
      if (a._e) return;
      a._e = true;
      var ms = $$('.e-ann__m', a);
      if (ms.length < 2) return;
      var d = (+a.getAttribute('data-durata') || 6) * 1000, i = 0, t = 0;
      function go() { ms[i].classList.remove('is-on'); i = (i + 1) % ms.length; ms[i].classList.add('is-on'); }
      function stop() { clearInterval(t); }
      function start() { stop(); if (!RM) t = setInterval(go, d); }
      a.addEventListener('mouseenter', stop);
      a.addEventListener('mouseleave', start);
      a.addEventListener('focusin', stop);
      a.addEventListener('focusout', start);
      a._stop = stop;
      a._show = function (m) { stop(); i = Math.max(0, ms.indexOf(m)); ms.forEach(function (x) { x.classList.toggle('is-on', x === m); }); };
      start();
    });
  }

  /* ---------------------------------------------------------------- comparse allo scorrimento e segni che si disegnano */
  var ANIM = H.classList.contains('e-anim') && 'IntersectionObserver' in window;
  var io = ANIM ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -4% 0px' }) : null;
  var ioDraw = ANIM ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      $$('.e-segno:not(.is-drawn)', e.target).forEach(function (s, k) { setTimeout(function () { s.classList.add('is-drawn'); }, 200 + k * 120); });
      ioDraw.unobserve(e.target);
    });
  }, { threshold: 0.3 }) : null;
  function initReveal(scope) {
    $$('[data-e-stagger]', scope).forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, k) { c.style.setProperty('--i', Math.min(k, 8)); });
    });
    var els = $$('[data-e-reveal],[data-e-reveal-img],[data-e-stagger],[data-e-line]', scope);
    if (scope && scope.matches && scope.matches('[data-e-reveal],[data-e-reveal-img],[data-e-stagger],[data-e-line]')) els.push(scope);
    els.forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });
    $$('[data-e-draw]', scope).forEach(function (el) {
      if (ioDraw) ioDraw.observe(el);
      else $$('.e-segno', el).forEach(function (s) { s.classList.add('is-drawn'); });
    });
  }

  /* ---------------------------------------------------------------- WhatsApp: compare dopo il primo scorrimento */
  var WAS = [];
  function initWA(scope) {
    $$('[data-e-wa]', scope).forEach(function (w) { if (w._e) return; w._e = true; WAS.push(w); });
    tickWA();
  }
  function tickWA() {
    var y = window.scrollY;
    WAS.forEach(function (w) { w.classList.toggle('is-on', y > (+w.getAttribute('data-dopo') || 0)); });
  }
  window.addEventListener('scroll', tickWA, { passive: true });

  /* ---------------------------------------------------------------- «Cookie Policy»: riapre le preferenze se il banner lo permette */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-e-consenso]');
    if (!a) return;
    var pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') { e.preventDefault(); pb.showPreferences(); }
  });

  /* ---------------------------------------------------------------- link che scorrono a una sezione della pagina
     («Trova il tuo momento», le stelle della scheda, «Scopri il percorso di…»): tengono conto dell'header */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-e-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, ''), el = id && document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    var hd = $('.e-hd-section'), off = hd ? hd.offsetHeight : 0;
    window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - off + 1), behavior: RM ? 'auto' : 'smooth' });
  });

  /* ---------------------------------------------------------------- la freccia dei link non va mai a capo da sola:
     l'ultima parola e la freccia restano insieme (Chrome spezza anche dopo &nbsp; davanti a un svg) */
  function glueArrows(scope) {
    scope.querySelectorAll('.e-ar').forEach(function (svg) {
      var prev = svg.previousSibling, par = svg.parentNode;
      if (!prev || prev.nodeType !== 3 || !par || par.getAttribute('data-e-nw') !== null) return;
      var d = getComputedStyle(par).display;
      if (d.indexOf('flex') > -1 || d.indexOf('grid') > -1) return;
      var m = prev.nodeValue.match(/(\S+\s*)$/);
      if (!m) return;
      prev.nodeValue = prev.nodeValue.slice(0, prev.nodeValue.length - m[1].length);
      var w = document.createElement('span');
      w.setAttribute('data-e-nw', '');
      w.style.whiteSpace = 'nowrap';
      w.appendChild(document.createTextNode(m[1]));
      par.insertBefore(w, svg);
      w.appendChild(svg);
    });
  }

  /* ---------------------------------------------------------------- carrello nell'header: il nome letto dai lettori di schermo segue il numero
     (data-e-cc = «1 gioiello nel carrello|[n] gioielli nel carrello», dalle traduzioni) */
  function initCc(scope) {
    $$('[data-e-cc]', scope).forEach(function (a) {
      if (a._ecc || !window.MutationObserver) return;
      var c = $('.e-hd__count', a), f = (a.getAttribute('data-e-cc') || '').split('|');
      if (!c || f.length < 2) return;
      a._ecc = true;
      var upd = function () { var n = parseInt(c.textContent, 10) || 0; a.setAttribute('aria-label', n === 1 ? f[0] : f[1].replace('[n]', n)); };
      new MutationObserver(upd).observe(c, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------------------------------------------------------------- avvio e editor di Shopify */
  function initAll(scope) {
    scope = scope || document;
    glueArrows(scope);
    initHeader(scope);
    initCc(scope);
    initAcc(scope);
    initAnn(scope);
    initReveal(scope);
    initWA(scope);
    if (window.EllesantiV3 && window.EllesantiV3.hooks) window.EllesantiV3.hooks.forEach(function (fn) { try { fn(scope); } catch (err) {} });
  }
  window.EllesantiV3 = window.EllesantiV3 || {};
  window.EllesantiV3.init = initAll;
  window.EllesantiV3.redraw = redraw;
  window.EllesantiV3.clamp = clamp;
  window.EllesantiV3.hooks = window.EllesantiV3.hooks || [];

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var mp = t.closest('[data-e-mp]');
    if (mp) { var hd = mp.closest('[data-e-hd]'); if (hd && hd._api) hd._api.open(mp.getAttribute('data-e-mp')); }
    if (t.classList.contains('e-ann__m')) { var a = t.closest('[data-e-ann]'); if (a && a._show) a._show(t); }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var t = e.target, mp = t && t.closest && t.closest('[data-e-mp]');
    if (mp) { var hd = mp.closest('[data-e-hd]'); if (hd && hd._api) hd._api.close(); }
  });
})();
